import { FC, PropsWithChildren, useCallback, useState } from 'react'

import { info } from '@/utils/logger.ts'

import { ReportWebsocketContext, ReportWebsocketState } from './useReportWebsocketContext'

export const ReportWebsocketContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [websocketState, setWebsocketState] = useState({})

  const updateState: ReportWebsocketState['updateState'] = useCallback((reportID, isGenerating) => {
    setWebsocketState((prev) => {
      info('updating report state', { reportID, isGenerating, websocketState: prev })
      return {
        ...prev,
        [reportID]: isGenerating,
      }
    })
  }, [])

  return (
    <ReportWebsocketContext.Provider
      value={{
        isGeneratingReport: websocketState,
        updateState,
      }}
    >
      {children}
    </ReportWebsocketContext.Provider>
  )
}
